import { render, staticRenderFns } from "./OrderBillSend.vue?vue&type=template&id=95715882&scoped=true"
import script from "./OrderBillSend.vue?vue&type=script&lang=js"
export * from "./OrderBillSend.vue?vue&type=script&lang=js"
import style0 from "./OrderBillSend.vue?vue&type=style&index=0&id=95715882&prod&scoped=true&lang=css"
import style1 from "./OrderBillSend.vue?vue&type=style&index=1&id=95715882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95715882",
  null
  
)

export default component.exports